import { ajax } from "../services/ajax"
import { api } from "../constants";

export const getTracksByTags = options => {
  return ajax.post(api.endpoints.tracksByTags, { filter: options });
}

export default text => {
  return ajax.get(api.endpoints.tracks(text))
}
